<template>
  <ul class="group-recommended-games">
    <li
      v-for="card in cards"
      :key="card.id"
      :class="`group-recommended-games__item_${card.id}`"
      class="group-recommended-games__item"
    >
      <span class="group-recommended-games__title">
        {{ getContent(globalComponentsContent, defaultLocaleGlobalComponentsContent, card.contentPath) }}
      </span>

      <div class="group-recommended-games__icon">
        <atomic-icon id="back" />
      </div>
    </li>
  </ul>
</template>
<script setup lang="ts">
  const globalStore = useGlobalStore();
  const { globalComponentsContent, defaultLocaleGlobalComponentsContent } = storeToRefs(globalStore);
  const { getContent } = useProjectMethods();

  const cards = [
    {
      id: 'region',
      contentPath: 'cardsGroup.regionGamesLabel',
    },
    {
      id: 'recommended',
      contentPath: 'cardsGroup.recommendedGamesLabel',
    },
  ];
</script>

<style src="~/assets/styles/components/group/recommended-games.scss" lang="scss" />
